import { useState } from "react";

function useCopyToClipboard() {
  const [feedback, setFeedback] = useState("");

  const copyToClipboard = async (text) => {
    try {
      await navigator.clipboard.writeText(text);
      setFeedback("Account Number copied to clipboard");

      // Automatically clear the feedback after a certain time (e.g., 3 seconds)
      setTimeout(() => {
        setFeedback("");
      }, 3000);
    } catch (err) {
      console.error("Unable to copy to clipboard:", err);
    }
  };

  return {
    feedback,
    copyToClipboard,
  };
}

export default useCopyToClipboard;
